import { httpClient } from './httpClient';

/**
 * 健康检查 API 模块
 */
export class HealthApi {
  /**
   * 健康检查
   */
  async healthCheck(): Promise<any> {
    return httpClient.get<any>('/health');
  }
}

// 导出单例实例
export const healthApi = new HealthApi();
